import { CombinedGraphQLErrors } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import { GraphQLError } from 'graphql/error';

import { isNetworkLost, serverErrorMessages } from './graph-errors';
import { NetworkStatusUpdateService } from './network-status/network-status-update.service';


function hasAuthenticationError(graphQLErrors: GraphQLError[]): boolean {
  return hasErrorCode(graphQLErrors, 'UNAUTHENTICATED');
}

function hasErrorCode(graphQLErrors: GraphQLError[], errorCode: string): boolean {
  return !!graphQLErrors.find((error: GraphQLError) => error?.extensions?.['code'] === errorCode);
}

export function createGraphqlErrorLink(networkService: NetworkStatusUpdateService, isProduction: boolean) {
  return new ErrorLink(({ error }) => {
    if ( CombinedGraphQLErrors.is(error) ) {
      const graphQLErrors = error.errors;
      if ( !isProduction ) {
        console.log('graphQLErrors', graphQLErrors);
      }
      if ( hasAuthenticationError(<GraphQLError[]>graphQLErrors) ) {
        if ( !isProduction ) {
          console.log('auth error', graphQLErrors)
        }
        // TODO: updateAuthenticationError is deliberately commented out below.
        // networkService.updateAuthenticationError(true);
        //this.store.dispatch(new SessionExpiredAction());
      }
    } else {
      // Everything that is not a GraphQL error result is the old networkError branch.
      if ( isNetworkLost(error) ) {
        networkService.updateConnected(false)
        // this.store.dispatch(new LostNetworkAction())
      } else {
        const messages = serverErrorMessages(error);
        if (messages.length) {
          error.message = error.message + ' - ' + messages.join('\n')
        }

        if ( !isProduction ) {
          console.log('network error', error);
        }
      }
    }
  });
}
